import SimpleLogo from "./svgs/simple_logo.svg";
import SSLogo from "./svgs/ss_logo.svg";
import RocketLaunch from "./svgs/rocket_launch.svg";

export const Svgs = { SimpleLogo, SSLogo, RocketLaunch };
